import { isMyMessage } from "@/utils/helpers";
import type { TMessageListState, TMessage } from "./message.types";

const selectAllApiMessages = (
  messageList: TMessageListState,
  myId: number,
): TMessage[] => {
  const messages = Array.isArray(messageList.source) ? messageList.source : [];
  return messages.map((message: TMessage) => ({
    ...message,
    itsMyMessage: isMyMessage(message.senderId, myId),
  }));
};

export const selectOlderMessages = (
  messageList: TMessageListState,
  myId: number,
): {
  source: TMessage[];
  hasOlderMessages: boolean;
  loadedOlderMessages: boolean;
} => {
  const allMessages = selectAllApiMessages(messageList, myId);
  const { start, end, hasOlderMessages, loadedOlderMessages } =
    messageList.pagination;
  return {
    source: allMessages.slice(start, end).reverse(),
    hasOlderMessages,
    loadedOlderMessages,
  };
};
